import React from 'react';

const VideoPlayer = ({ videoId, width = 853, height = 480}: any) => {
  return (
    <div className="video-responsive">
      <iframe
        width={String(width)}
        height={String(height)}
        src={`https://www.youtube.com/embed/${videoId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    </div>
  );
};

export default VideoPlayer;